import gsap from 'gsap';

export class PartnerStamp {
    constructor(container) {
        this.partnerStampEl = container.querySelector('.gom-head .logo-partner');
        if (!this.partnerStampEl) return;

        gsap.set(this.partnerStampEl, {
            scale: 3,
            opacity: 0,
            rotation: 25,
        });

        this.animate();
    }

    animate() {
        if (!this.partnerStampEl) return;

        this.animation = gsap.to(this.partnerStampEl, {
            scale: 1,
            opacity: 1,
            rotation: -10,
            duration: 0.6,
            ease: 'back.out(1.7)',
            delay: 1,
        });
    }

    dispose() {
        if (this.animation) {
            this.animation.kill();
        }
        
        if (this.partnerStampEl) {
            gsap.set(this.partnerStampEl, {
                clearProps: 'all'
            });
        }

        this.partnerStampEl = null;
        this.animation = null;
    }
} 